import React, { PureComponent } from 'react';
import { UserComponent } from '../UserComponent';
import { LeaguePlayerComponent } from '../LeaguePlayerComponent';

export default class MatchHistoryPlayerComponent extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			extraStatsShown: false,
		};
		this.statsClick = this.statsClick.bind(this);
	}

	statsClick() {
		this.setState(prevState => ({
			extraStatsShown: !prevState.extraStatsShown
		}));
	}

	render() {
		const { matchPlayer, ladderId, match } = this.props;
		const { extraStatsShown } = this.state;
		if(!matchPlayer) {
			console.error('had no player');
			return null;
		}
		const { player } = matchPlayer;

		let leagueToUse = null;

		let leagueProps = {};
		if(match && player) {
			leagueProps = match.getLeagueInformationForPlayer(player);
			leagueToUse = leagueProps.league;
		}
		else if(player && player.ladder_information) {
			leagueToUse = player.ladder_information.getLeagueForLadder(ladderId);
		}

		const previousLeague = matchPlayer && matchPlayer.match && matchPlayer.match.previous_league;
		const pointsPositive = previousLeague && previousLeague.change && previousLeague.change.points > 0;
		const pointsNegative = previousLeague && previousLeague.change && previousLeague.change.points < 0;

		return (
			<div
				onClick={this.statsClick}
				className='opponent selected'>
				<UserComponent
					user={player}
				/>
				<div className='opponent_stats'>
					{!!previousLeague &&
					<div className='advanced_stats previous_league'>
						<LeaguePlayerComponent
							league={previousLeague}
							extraClasses='medal_summary'
							requirementsNecessaryToBeDisplayed={false}
							showBlankDivisionForUnranked
							showRawPoints={myUser.permissions.game_master}
							showUnrankedForMissingLeague
						/>
						{extraStatsShown && myUser.permissions.game_master && !!previousLeague.change &&
						<React.Fragment>
							<div
								className={`point_change ${pointsPositive ? 'is_positive' : ''} ${pointsNegative ? 'is_negative' : ''}`}>
								{pointsPositive && '+'}{previousLeague.change.points}
							</div>
							<div className='standard_deviation_change'>
								{previousLeague.change.start_deviation} -> {previousLeague.change.end_deviation}
							</div>
						</React.Fragment>
						}
					</div>
					}
					{(extraStatsShown || !previousLeague) &&
					<LeaguePlayerComponent
						{...leagueProps}
						league={leagueToUse}
						extraClasses='medal_summary'
						requirementsNecessaryToBeDisplayed={false}
						showBlankDivisionForUnranked
						hidePoints={!match.isRanked()}
						showRawPoints={extraStatsShown && myUser.permissions.game_master}
						showUnrankedForMissingLeague
					/>
					}

				</div>
			</div>
		);
	}
}